'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var device_consts = require('./device.consts-2b011893.js');

var mediaMaxWidth = function (styles, maxWidth) {
    if (maxWidth === void 0) { maxWidth = device_consts.SMALL_DEVICE_MAX_WIDTH + "px"; }
    return styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  @media only screen and (max-width: ", ") {\n    ", "\n  }\n"], ["\n  @media only screen and (max-width: ", ") {\n    ", "\n  }\n"])), maxWidth, styles);
};
var templateObject_1;

exports.mediaMaxWidth = mediaMaxWidth;
